import Icon from '../components/Icon.vue'

Icon.register({"play-circle":{"width":512,"height":512,"paths":[{"d":"M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM371.7 280L195.7 381C179.9 389.8 160 378.5 160 360V152C160 133.6 179.8 122.2 195.7 131L371.7 238C388.1 247.2 388.1 270.9 371.7 280z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/play-circle.js
// module id = X/kT
// module chunks = 0